import React, { useEffect, useState } from "react";
import Layout from "../../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../../elements/list/list";
import { Container } from "../../../common/layout/styels";
import ViewFiles from "../../documents/ViewFiles";
import { useSelector } from "react-redux";
import { getData } from "../../../../../backend/api";
// import NationalityChart from "./chart";
const HolidayAccountReport = (props) => {
  const { t } = useTranslation();

  const user = useSelector((state)=> state.login)

  const [userCountNation, setUserCountNation] = useState([]);

  const [attributes] = useState([
    {
      type: "number",
      placeholder: "personalNumber",
      name: "personalNumber",
      tab: "generalInfo",
      validation: "",
      default: user?.data?.highestPersonnelNumber,
      label: "personalNumber",
      required: false,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "--",
      name: "firstName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "firstName",
      required: false,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "--",
      name: "lastName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "lastName",
      required: false,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "select",
      placeholder: "select",
      name: "department",
      tab: "generalInfo",
      validation: "",
      showItem: "title",
      default: "",
      label: "department",
      required: true,
      view: true,
      tag: true,
      add: true,
      update: true,
      apiType: "API",
      selectApi: "department/select",
      filter: true
    },
    {
      type: "number",
      placeholder: "enterDays",
      name: "vacationPerYear",
      tab: "official",
      validation: "number",
      default: "0",
      label: "vacationPerYear",
      required: false,
      view: true,
      tag: true,
      add: false,
      update: true,
    },
    {
      type: "number",
      placeholder: "enterDays",
      name: "vacationTaken",
      tab: "official",
      validation: "number",
      default: "0",
      label: "vacationTaken",
      required: false,
      view: true,
      tag: true,
      add: false,
      update: true,
    },
    {
      type: "number",
      placeholder: "enterDays",
      name: "vacationRemaining",
      tab: "official",
      validation: "number",
      default: "0",
      label: "vacationRemaining",
      required: true,
      view: true,
      tag: true,
      add: false,
      update: false,
    },
    
  ]);

  //to update the page title
  useEffect(() => {
    document.title = `${t("illness")} - PersoBase`;
  }, [t]);
  

  // Use the useTranslation hook from react-i18next to handle translations
  // const parkingDuration = totalDuration > 120 ? (days > 0 ? days + `d, ` : ``) + (hours > 0 ? hours + `h, ` : ``) + (minutes + t("m")) : totalDuration.toFixed(0) + ` ` + t("minutes");
  return (
    <Container style={{flexDirection:'column'}} className="noshadow">
      <ListTable bulkUplaod={false} {...props} api={`user`} itemTitle={`fullName`} shortName={`holiday-account`} viewDetails={false} addPrivilege={false} delPrivilege={false} updatePrivilege={false} selectPrivilege={false} attributes={attributes} formMode="double" moreOptions={false} popUpUsingId={false} chart={false} datefilter={true} ></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(HolidayAccountReport);
